import { Suspense } from 'react'

function RentalPortalActiveItemPreview({ Component, ...restProps }) {
  return (
    <Suspense fallback={null}>
      <Component {...restProps} />
    </Suspense>
  )
}

export default RentalPortalActiveItemPreview
